<template>
  <div class="section section--instagram">
    <div class="container">
      <h2 class="section__title">{{ $t('instagram.title') }}</h2>

      <!-- <p class="section__message" v-html="$t('instagram.text')"></p> -->
      <p class="section__message" v-html="$t('social.text')"></p>

      <ul class="social-list">
        <li>
          <a href="https://fb.com/ebanxbr" rel="noopener" target="_blank" :title="$t('social.follow.facebook')">{{ $t('social.follow.facebook') }} <i class="icon icon--facebook"></i></a>
        </li>
        <li>
          <a href="https://instagram.com/ebanxlife" rel="noopener" target="_blank" :title="$t('social.follow.instagram')">{{ $t('social.follow.instagram') }} <i class="icon icon--instagram"></i></a>
        </li>
        <li>
          <a href="https://twitter.com/EbanxBR" rel="noopener" target="_blank" :title="$t('social.follow.twitter')">{{ $t('social.follow.twitter') }} <i class="icon icon--twitter"></i></a>
        </li>
        <li>
          <a href="https://www.linkedin.com/company/ebanx/" rel="noopener" target="_blank" :title="$t('social.follow.linkedin')">{{ $t('social.follow.linkedin') }} <i class="icon icon--linkedin"></i></a>
        </li>
      </ul>
    </div>

    <!-- <ul class="instagram-feed">
      <li v-for="pic in instagramPics" :key="pic.id">
        <img v-lazy="pic.images.standard_resolution.url" :title="pic.caption.text">

        <a :href="pic.link" :title="pic.caption.text" target="_blank" rel="noopener"></a>
      </li>
    </ul> -->
  </div>
</template>

<style scoped>
.instagram-feed {
  flex-direction: row;
  align-items: stretch;
  justify-content: space-between;

  &,
  li {
    position: relative;
    display: flex;
    flex-wrap: wrap;
  }

  li {
    align-items: center;
    justify-content: center;
    flex-basis: 50%;
    height: 14rem;
    opacity: 1;
    transition: all ease-in-out 200ms;

    &:hover {
      opacity: 0.9;
    }

    &:last-child {
      display: none;
    }

    img {
      height: 100%;
      flex: 1;
      object-fit: cover;
    }

    a {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }
  }

  @media screen and (min-width: 768px) {
    li {
      flex-basis: 20%;
      height: 19rem;

      &:last-child {
        display: block;
      }
    }
  }
}
</style>

<script>
export default {
  name: "InstagramFeed",
  computed: {
    instagramPics() {
      return this.$store.getters.instagramFeed;
    }
  }
};
</script>
